import { Stack, Switch, Text } from "@mantine/core";
import type {
	AssistantVoiceExperimentsText,
	VoiceExperimentKey,
} from "@/locales/assistant-voice-experiments";

const KEYS: readonly VoiceExperimentKey[] = [
	"voiceFillerEnabled",
	"voiceEchoFilterEnabled",
	"voiceOpenerEnabled",
	"voiceStyleLayerEnabled",
];

interface Props {
	t: AssistantVoiceExperimentsText;
	values: Record<VoiceExperimentKey, boolean>;
	disabled: boolean;
	onChange: (key: VoiceExperimentKey, value: boolean) => void;
}

/** Sakelar eksperimen suara (#62), bawaan mati — berlaku di sesi suara berikutnya. */
export function StyleVoiceExperiments({
	t,
	values,
	disabled,
	onChange,
}: Props) {
	return (
		<Stack gap="xs" data-voice-experiments>
			<Text fw={600}>{t.title}</Text>
			<Text size="sm" c="dimmed">
				{t.description}
			</Text>
			{KEYS.map((key) => (
				<Switch
					key={key}
					label={t.items[key].label}
					description={t.items[key].hint}
					checked={values[key]}
					disabled={disabled}
					onChange={(e) => onChange(key, e.currentTarget.checked)}
					data-voice-experiment={key}
				/>
			))}
			<Text size="xs" c="dimmed">
				{t.waitSoundNote}
			</Text>
		</Stack>
	);
}
